<template>
    <div class="sendPlace">
        <el-breadcrumb class="Breadcrumb" separator="/">
            <el-breadcrumb-item>场地管理</el-breadcrumb-item>
        </el-breadcrumb>
        <el-divider></el-divider>
        <div class="search">
            <el-row :gutter="24">
                <el-col :span="6" :offset="0">
                    <el-cascader placeholder="请选择场地区域" :value="fullDdicId"  clearable :options="selectfullDdicId" filterable
                        @change="handleChange"></el-cascader>
                </el-col>
                <el-col :span="6" :offset="0">
                    <el-select v-model="size" filterable  clearable placeholder="请选择场地面积">
                        <el-option v-for="item in selectSize" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </el-col>
                <el-col :span="6" :offset="0">
                    <el-select v-model="payWay" filterable  clearable placeholder="请选择支付方式">
                        <el-option v-for="item in selectPayWay" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </el-col>
                <el-col :span="4">
                    <el-button type="primary" @click="getListFun(1)" icon="el-icon-search">查询</el-button>
                    <el-button type="primary" @click="openAdd()" icon="el-icon-plus">添加</el-button>
                </el-col>
            </el-row>
        </div>
        <el-divider></el-divider>
        <div class="table">
            <el-table :data="tableData" stripe style="width: 100%">
                <el-table-column prop="title" label="标题"></el-table-column>
                <el-table-column prop="titleImage" label="展示图片">
                    <template slot-scope="scpoe">
                        <img style="width: 100px; height: 100px;" :src="scpoe.row.titleImage" fit="contain" @click="showImage(scpoe.row.titleImage)">
                    </template>
                </el-table-column>
                <el-table-column prop="ddic" label="所在区域"></el-table-column>
                <el-table-column prop="titleImage" label="场地大小">
                    <template slot-scope="scpoe">
                        <span>{{scpoe.row.size+'㎡'}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="linkman" label="联系人"></el-table-column>
                <el-table-column prop="mobile" label="联系电话"></el-table-column>
                <el-table-column prop="payWayStr" label="支付方式"></el-table-column>
                <el-table-column label="启用/禁用">
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.isUsed" active-color="#13ce66" inactive-color="#ff4949"
                            :disabled="scope.row.canEdit == false" @change="changeDemo(scope.row.id, scope.row.isUsed)">
                        </el-switch>
                    </template>
                </el-table-column>
                <el-table-column label="发布周期时间" width="230">
                    <template slot-scope="scpoe">
                        <span>{{scpoe.row.sendStartDate+' - '+scpoe.row.sendEndDate}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="id" fixed="right" label="操作" width="200">
                    <template slot-scope="scope">
                      <el-button @click="topFun(scope.row.id)" type="text" icon="el-icon-upload2"
                                 size="small">置顶</el-button>
                      <el-button @click="upFun(scope.row.id)" type="text" icon="el-icon-caret-top"
                                 size="small">上移</el-button>
                      <el-button @click="downFun(scope.row.id)" type="text" icon="el-icon-caret-bottom"
                                 size="small">下移</el-button>
                      <el-button @click="bottomFun(scope.row.id)" type="text" icon="el-icon-download"
                                 size="small">置底</el-button>
                      <el-button @click="openEdit(scope.row)" type="text" icon="el-icon-edit" size="small">编辑</el-button>
                      <el-button @click="deleteFun(scope.row.id)" type="text" icon="el-icon-delete"
                          size="small">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!--分页-->
        <div class="pagination">
            <el-pagination background @size-change="changSizeFun" @current-change="changpageFun"
                :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
                :total="totalNum">
            </el-pagination>
        </div>
      <!-- 添加弹窗-->
      <el-dialog :title="popTitle" :visible.sync="addPop" @close="resetForm('ruleForm')" :close-on-click-modal="false">
        <el-form :model="formDate" :rules="rules" ref="ruleForm" label-width="120px">
          <el-form-item label="标题" prop="title">
            <el-input placeholder="请输入标题" v-model="formDate.title" ></el-input>
          </el-form-item>
          <el-form-item label="所在区域" prop="fullDdicId">
            <el-cascader placeholder="请选择所在区域" v-model="formDate.fullDdicId"  clearable :options="selectfullDdicId"
                         filterable @change="selectPlaceDataZoneChange" style="width: 100%;"></el-cascader>
          </el-form-item>
          <el-form-item label="场地大小" prop="size" >
            <el-input clearable placeholder="请输入场地大小" v-model="formDate.size"></el-input>
          </el-form-item>
          <el-form-item label="联系人" prop="linkman">
            <el-input placeholder="请输入联系人" v-model="formDate.linkman"></el-input>
          </el-form-item>
          <el-form-item label="联系人电话" prop="mobile">
            <el-input placeholder="请输入联系人电话" v-model="formDate.mobile"></el-input>
          </el-form-item>
          <el-form-item label="场地描述" prop="description">
            <el-input size="small" type="textarea"  placeholder="请输入项目描述" v-model="formDate.description"></el-input>
          </el-form-item>
          <el-form-item label="支付方式" prop="payWay">
            <el-select class="inner-input" v-model="formDate.payWay" filterable  clearable placeholder="请选择支付方式">
              <el-option v-for="item in selectPayWay" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="发布周期时间" prop="sendDate">
            <el-date-picker
              @change="changeTime"
              v-model="formDate.sendDate"
              class="inner-input"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="标题图片" prop="titleImage" class="upload-Image">
            <el-upload class="upload-demo" drag :show-file-list="false" :action="uploadUrl" :headers="upheader"
                       :on-success="handleSuccess"
                       :on-preview="handlePictureCardPreview"
                       :on-remove="handleRemove" >
              <template v-if="!formDate.titleImage">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
              </template>
<!--              <img v-else style="width: 200px; height: 200px;" :src="formDate.filePath" fit="contain">-->
              <img v-else style="width: 100%; height: 100%;" :src="formDate.filePath" fit="widthFix">
              <!-- <el-image v-else style="width: 100%;" :src="formDate.image" fit="contain"></el-image> -->
            </el-upload>
          </el-form-item>


        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="resetForm('ruleForm')">取 消</el-button>
          <el-button type="primary" @click="addNewsFun('ruleForm')">确 定</el-button>
        </div>
      </el-dialog>
    </div>
</template>

<script>

export default {
    mounted() {
        this.getSelect();
        this.getListFun(1);
    },
    methods: {
        getSelect() {
            let data = {
            }
            this.$get(api + "/siteManager/getSelectZONE", data).then(response => {
                let res = response.data;
                if (res.code == 0) {
                    this.selectfullDdicId = res.data;
                }
            })
            this.$get(api + "/siteManager/getSelectSize", data).then(response => {
                let res = response.data;
                if (res.code == 0) {
                    this.selectSize = res.data;

                }
            })
            this.$get(api + "/siteManager/getSelectPayWay", data).then(response => {
                let res = response.data;
                if (res.code == 0) {
                    this.selectPayWay = res.data;

                }
            })
        },
        getList() {
            let fdid = this.fullDdicId.toString();
            let data = {
                fullDdicId: fdid,
                size: this.size,
                payWay: this.payWay,
                pageSize: this.pageSize,
                pageNum: this.pageNum,
            }
            console.log('data',data)
            this.$get(api + "/siteManager/getList", data).then(response => {
                let res = response.data;
                if (res.code == 0) {
                    this.tableData=res.data;
                    this.totalNum = res.totalNum
                }
            })
        },
        handleChange(value) {
            this.fullDdicId = value;
        },
        showImage(imagePath){
            // alert(imagePath);
          window.open(imagePath)
        },
        //开启/关闭用户
        changeDemo(id, isUsed) {
            //true = 开启 false = 关闭
            let data = {}
            let uri = isUsed ? "enable" : "disable"
            let url = "/siteManager/" + uri + "/" + id;
            this.$post(api + url, data).then(response => {
                let res = response.data;
                if (res.code == 0) {
                    this.getListFun(this.pageNum);
                } else {
                    this.$message.error(res.desc);
                }
            })
        },
         //特定pageNum查询列表
         getListFun(val) {
            this.pageNum = val;
            this.getList();
        },
        //换位置
        changePlace(url) {
          let data = {}
          this.$post(api + url, {}).then(response => {
            let res = response.data;
            if (res.code == 0) {
              this.getListFun(this.pageNum);
            } else {
              this.$message.error(res.desc);
            }
          })
        },
        topFun(id) {
          let url = "/siteManager/top/" + id;
          this.changePlace(url);
        },
        upFun(id) {
          let url = "/siteManager/up/" + id;
          this.changePlace(url);
        },
        downFun(id) {
          let url = "/siteManager/down/" + id;
          this.changePlace(url);
        },
        bottomFun(id) {
          let url = "/siteManager/bottom/" + id;
          this.changePlace(url);
        },
        //更换pageSize
        changSizeFun(val) {
            console.log(`每页 ${val} 条`);
            this.pageSize = val;
        },
        handlePictureCardPreview(file){
          console.log(file)
        },
        handleRemove(file, fileList){
          console.log(file, fileList)
        },
        handleSuccess(response, file, fileList) {
          console.log('this.formDate',this.formDate)
          // 这里可以根据你的需要自定义成功后的操作
          // console.log('文件上传成功');
          // console.log('服务器返回的响应：', response);
          // console.log('已上传的文件：', file);
          // console.log('所有已上传的文件：', fileList);
          this.formDate.titleImage = response.data.url;
          console.log('this.formDate.titleImage',this.formDate.titleImage)
          this.formDate.filePath = response.data.fullUrl;
          this.addPop = false;
          this.addPop =true;
        },
        //翻页
        changpageFun(val) {
            console.log(this.pageNum);
            this.pageNum = val;
        },
        openAdd() {
          this.formDate = {};
          this.addPop = true;
          this.popTitle = '添加场地';
          this.formDate.titleImage = '';
          this.formDate.filePath = '';
        },
        //添加编辑场地
        addNewsFun(formName){
          console.log('this.formData',this.formDate)
          let formDate = {
            description:this.formDate.description,
            title:this.formDate.title,
            titleImage:this.formDate.titleImage,
            sendStartDate:this.formDate.sendStartDate,
            sendEndDate:this.formDate.sendEndDate,
            linkman:this.formDate.linkman,
            mobile:this.formDate.mobile,
            id:this.formDate.id,
            payWay:this.formDate.payWay,
            size:this.formDate.size,
          }
          if(this.formDate.fullDdicId && this.formDate.ddicId){
            formDate.fullDdicId = this.formDate.fullDdicId.toString(),
            formDate.ddicId = this.formDate.ddicId
          }
          this.$refs[formName].validate((valid) => {
            if (valid) {
              console.log('111')
              if(!this.formDate.id){
                this.$post(api + "/siteManager/addNewsPress", formDate).then(response => {
                  let res = response.data;
                  if (res.code == 0) {
                    this.$message({
                      type: 'success',
                      message: '添加成功!'
                    })
                    this.formDate = {};
                    this.addPop = false;
                    this.getListFun(1);
                  } else {
                    this.$message.error(res.desc);
                  }
                })
              }else{
                this.$post(api + "/siteManager/editNewsPress", formDate).then(response => {
                  let res = response.data;
                  if (res.code == 0) {
                    this.$message({
                      type: 'success',
                      message: '编辑成功!'
                    })
                    this.formDate = {};
                    this.addPop = false;
                    this.getListFun(1);
                  } else {
                    this.$message.error(res.desc);
                  }
                })
              }
            } else {
              console.log('error submit!!');
              return false;
            }
          });


        },
        resetForm(formName){
          this.$refs[formName].resetFields();
          this.addPop = false;
        },
        selectPlaceDataZoneChange(value){
          if(value){
            this.formDate.ddicId = value[value.length-1]
            console.log('this.formDate.ddicId',this.formDate.ddicId)
          }
        },
        changeTime(value){
          this.formDate.sendStartDate = value[0]
          this.formDate.sendEndDate = value[1]
        },
        openEdit(data){
            console.log(data);
            this.formDate = {
              sendDate : [data.sendStartDate,data.sendEndDate],
              filePath : data.titleImage,
              description:data.description,
              title:data.title,
              linkman:data.linkman,
              mobile:data.mobile,
              id:data.id,
              titleImage:data.titleImage,
              payWay:data.payWay,
              size:data.size,
              fullDdicId: data.fullDdicId.toString(),
              fddicId : data.ddicId
            }
            this.addPop = true;
            this.popTitle = '编辑场地'
        },
        deleteFun(data){
          console.log(data)
          this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$post(api + '/siteManager/delete/'+data,{}).then(res=>{
              if(res.data.code === 0){
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                })
                this.getListFun()
              }
            })
          }).catch(() => {

          });

        },
    },

    data() {
        var checkMobole = (rule,value,callback)=>{
          if(!value){
            return callback(new Error('手机号不能为空'))
          }
          const regex = /^1[3456789]\d{9}$/;
          if(regex.test(value)){
            return callback()
          }else{
            return callback(new Error('请输入正确的手机号'))
          }
        };
        return {
            fullDdicId: [],
            size: [],
            payWay: [],
            selectfullDdicId: [],
            selectSize: [],
            selectPayWay: [],
            options: [],
            pageSize: 10,
            pageNum: 1,
            tableData: [],
            totalNum: 0,
            popTitle:'',
            addPop:false,
            formDate:{
              id:''
            },
            uploadUrl:api + '/main/' + 'sendPlace' + '/upload',
            upheader:{ "token": this.$store.state.userInfo.token },
            rules:{
              title: [
                { required: true, message: '请输入标题', trigger: 'blur' },
                { min: 1,  message: '请至少输入1个字', trigger: 'blur' }
              ],
              fullDdicId: [
                { required: true, message: '请选择所在区域', trigger: 'blur' },
              ],
              description: [
                { required: true, message: '请输入场地描述', trigger: 'blur' },
                {min:5,message:'至少输入5个字'}
              ],
              size: [
                { required: true, message: '请输入场地大小', trigger: 'blur' },
              ],
              linkman: [
                { required: true, message: '请输入联系人', trigger: 'blur' },
              ],
              mobile: [
                // { required: true, message: '请输入联系人电话号', trigger: 'blur' },
                { validator: checkMobole, trigger: 'blur' ,required: true,}
              ],
              payWay: [
                { required: true, message: '请选择支付方式', trigger: 'blur' },
              ],
              sendDate: [
                { required: true, message: '请选择发布周期', trigger: 'blur' },
              ],
              titleImage:[
                {required: true, message:'请输入图片',trigger:'blur'}
              ]
            }
        };
    }
};
</script>
<style scoped>
  .upload-Image{

  }
  .upload-demo{

  }
  .inner-input{
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/pages/innovation/SendPlace.vue